<template>
  <td v-if="renderCell" class="actions-template" :class="className">
    <div class="w-full h-full flex flex-row gap-2 items-center">
      <base-button-icon
        class="action-button"
        v-for="action in value"
        :key="action[actionIdField]"
        :id="action[actionIdField]"
        :name="action[actionIconField]"
        size="xs" icon-size="xsm"
        @click.stop="onClickAction"
      />
    </div>
  </td>
  <td v-else-if="renderArrow" :key="`g-${columnIndex}`" class="k-group-cell" />
  <td v-else-if="renderGroup" key="g-colspan" class="actions-template" :colSpan="columnsCount - columnIndex">
    <p class="k-reset">
      <a @click="$emit('click', $event, dataItem, expanded)" tabIndex="-1" href="#" :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'

export default {
  name: 'actions-template',
  props: {
    tableId: [String, Number],
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    type: {
      type: String,
      default: 'Text'
    },
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    renderGroup () {
      return this.columnIndex <= this.level
    },
    value: function () {
      return this.extraparams?.actions ?? []
    },
    groupHeader () {
      return ''
    },
    actionIdField: function () {
      return this.extraparams?.actionId ?? 'idAccion'
    },
    actionIconField: function () {
      return this.extraparams?.actionIcon ?? 'icon'
    },
  },
  methods: {
    onClickAction (event) {
      const idAccion = event.target.closest('.action-button').id
      const dataItem = this.dataItem
      const action = this.value.find(x => x[this.actionIdField]?.toString() === idAccion)
      if (action) {
        this.$emit('actionclick', { dataItem, action, event })
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: idAccion }))
      }
    }
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
.k-grid td.editable {
  text-overflow: clip;
}
.k-grid td.editable::v-deep .el-input__inner {
  min-width: calc(30px + 1em);
}
</style>
